module.exports = __webpack_public_path__ + "img/43_42.a3dfab0a.png";